import { useState, useEffect } from "react";
import { IMAGE_BASE_PATH } from "../config";



const useLoadImages = ({ prefijo, listadoImagenes, posicion, extencion, primerInicio, sufijo }) => {
  const [images, setImages] = useState([]);
  const [urls, setUrls] = useState([]);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const urlRepoImagen = IMAGE_BASE_PATH


  const fetchData = async () => {
    setIsLoading(true);


    const data = listadoImagenes.map(async (auxSrc) => {
      const src = `${urlRepoImagen}${prefijo}${auxSrc}${sufijo}.${extencion}`
      return await fetch(src)
        .then(async (data) => ({ status: data.status, blob: await data?.blob(), dateTime: auxSrc, url: src }))
        .catch((error) => setError(error));
    })

    const responses = await Promise.allSettled(data)

    const auxImages = []
    const auxUrls = []
    responses.forEach((response) => {
      if (response.value.status !== 200) return
      const objectURL = URL.createObjectURL(response.value.blob);

      auxImages[response.value.dateTime] = objectURL
      auxUrls[response.value.dateTime] = response.value.url
    })

    setImages(auxImages);
    setUrls(auxUrls);
    setIsLoading(false);

  }
  useEffect(() => {
    fetchData();
  }, []);

  return { images, error, fetchData, isLoading, urls };
};

export default useLoadImages;